import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import '@capacitor/core';

import { SplashScreen } from '@capacitor/splash-screen';

import { isLoggedIn } from './lib/functionality';

// Importing app fonts
import './fonts/Roboto-Regular.woff';
import './fonts/Roboto-Regular.woff2';
import './fonts/Roboto-Italic.woff';
import './fonts/Roboto-Italic.woff2';
import './fonts/Roboto-Bold.woff';
import './fonts/Roboto-Bold.woff2';
import './fonts/Roboto-BoldItalic.woff';
import './fonts/Roboto-BoldItalic.woff2';
import './fonts/Roboto-Medium.woff';
import './fonts/Roboto-Medium.woff2';
import './fonts/Roboto-MediumItalic.woff';
import './fonts/Roboto-MediumItalic.woff2';

SplashScreen.show();

isLoggedIn()
  .then(loginStatus => {
    const container = document.getElementById('root');
    const root = createRoot(container!);
    root.render(<App isLoggedIn={loginStatus} />);
    SplashScreen.hide();
  })
  .catch(err => {
    console.error(err);
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
